var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"bg-gray-50"},[_c('tr',[_c('th',{staticClass:"px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex-1",attrs:{"scope":"col"}},[_vm._v(" Name ")]),_c('th',{staticClass:"px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-32 text-right",attrs:{"scope":"col"}},[_vm._v(" Date Created ")])])])
}]

export { render, staticRenderFns }